module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel03_1280_1280_en-862f1582015e52cc87eac03a74f26db6.jpg";